// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__20elJ","footer":"ChangeClinic_footer__2YWAF"};